<script lang="ts">
  import { i18n, showErrorMessage } from '@/plugins/util'
  import QRCode from '@/components/QR.svelte'
  import PageTopupSuccess from '@/components/appDriver/topup/PageTopupSuccess.svelte'
  import { topupPaymentGatewayResult, topupResult } from '@/components/appDriver/store'
  import { onDestroy, onMount } from 'svelte'
  import PubNub from 'pubnub'
  import { isLoading, lang } from '@/store'
  import { axiosInstance } from '@/plugins/axios'
  import PubSub from 'pubsub-js'
  import axios from 'axios'

  let pubnub: PubNub | undefined = undefined
  let pubnubListener: PubNub.Listener | undefined = undefined
  let pubnubChannels: string[] = []

  onMount(() => {
    pubnubChannels = $topupPaymentGatewayResult?.pubnubChannels ?? []

    initialPubNub()
    pubnubSubscribe()
  })

  onDestroy(() => {
    if (pubnubListener) {
      pubnubUnsubscribe()
      pubnub?.removeListener(pubnubListener)
    }
  })

  function initialPubNub() {
    pubnub = new PubNub({
      subscribeKey: $topupPaymentGatewayResult!.pubnubSubKey,
      userId: 'e190ac5f-ee8b-4161-8842-0070cc61140b',
      ssl: true,
    })

    pubnubListener = {
      status: event => {
        if (event.category === 'PNNetworkUpCategory') {
          pubnubSubscribe()
        }
      },
      message: event => {
        console.log('PUBNUB_PAYMENT_MESSAGE', event)

        type PaymentMessage = {
          billNumber: string
          txnDateTime: string
          refNo: string
          txnAmount: number
        }

        const paymentData = JSON.parse(event.message.toString()) as PaymentMessage

        // Check if bill number is matched
        if ($topupPaymentGatewayResult?.billNumber !== paymentData.billNumber) {
          console.log('Skip bill number not match', {
            serverBillNumber: $topupPaymentGatewayResult?.billNumber,
            paymentBillNumber: paymentData.billNumber,
          })
          return
        }

        pubnub?.unsubscribeAll()

        $topupResult = {
          paidAt: paymentData.txnDateTime,
          paymentRef: paymentData.refNo,
          amount: paymentData.txnAmount,
        }

        PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupSuccess })
      },
    }

    pubnub.addListener(pubnubListener)
  }

  function pubnubSubscribe() {
    pubnubUnsubscribe()
    pubnub?.subscribe({ channels: pubnubChannels })
    console.info(`PUBNUB_PAYMENT_SUBSCRIBE_CHANNELS`, pubnubChannels)
  }

  function pubnubUnsubscribe() {
    pubnub?.unsubscribe({ channels: pubnubChannels })
    console.info(`PUBNUB_PAYMENT_UNSUBSCRIBE_CHANNELS`, pubnubChannels)
  }

  async function confirmPayment() {
    try {
      $isLoading = true

      const { data } = await axiosInstance.post('/webapp/driver/topup/check-payment', {
        'bill_number': $topupPaymentGatewayResult?.billNumber,
      })

      $topupResult = {
        paidAt: data['paid_at'],
        paymentRef: data['payment_ref'],
        amount: data['amount'],
      }

      PubSub.publish('DRIVER.CHANGE_PAGE', { component: PageTopupSuccess })

      $isLoading = false
    } catch (error) {
      console.error('DRIVER_CONFIRM_PAYMENT_ERROR', error)
      $isLoading = false

      if (axios.isAxiosError(error)) {
        if (error.response) {
          showErrorMessage(error.response.data.message)
        } else if (error.request) {
          showErrorMessage(i18n($lang, ['Cannot connect to server, please try again', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ລະບົບ ກະລຸນາລອງໃໝ່']))
        } else {
          showErrorMessage(i18n($lang, ['Please try again', 'ກະລຸນາລອງໃໝ່']))
        }
      } else {
        showErrorMessage(i18n($lang, ['Please try again', 'ກະລຸນາລອງໃໝ່']))
      }
    }
  }
</script>

<main class="flex-1 overflow-y-scroll px-4">

  <img src="{new URL('@/assets/general/locapay-logo.png', import.meta.url).href}" class="w-5/12 mx-auto">

  <div class="space-y-4 mt-8">
    <div class="text-xl text-center font-semibold">ສະແກນເພື່ອຊຳລະ</div>
    <div class="w-max mx-auto bg-white p-4 rounded-lg shadow">
      <QRCode value={$topupPaymentGatewayResult?.qr} size={240}/>
    </div>
    <div class="text-center">
      <div class="text-sm font-light">ເລກອ້າງອີງ</div>
      <div>{$topupPaymentGatewayResult?.billNumber}</div>
    </div>
  </div>

</main>

<div class="rounded-lg border border-[#E80000] bg-[#F8F8F8] p-4 m-8 text-[#E80000] text-center text-2xl font-bold">LAK {$topupPaymentGatewayResult?.amount?.toLocaleString()}</div>

<div class="h-14 bg-[#1D3549] mt-auto flex justify-center items-center text-white text-xl font-semibold" on:click={confirmPayment}>ກວດສອບ</div>
